import { Routes, Route } from 'react-router-dom'
import Login from './auth/Login'
import AdminRedirectRoute from './auth/AdminRedirectRoute'
import AdminPrivateRoute from './auth/AdminPrivateRoute'
import Header from '../shared/Header'
import LuckyDraw from './central-networking-night/Page'
import WinnerPicker from './central-networking-night/WinnerPicker'
import Promotions from './promotions/Page'

const Page = () => {
  return (
    <Routes>
      <Route element={<AdminPrivateRoute />}>
        <Route path='/panel' element={<LuckyDraw />} />
        <Route path='/lucky-draw' element={<WinnerPicker />} />
        <Route path='/promotions/*' element={<Promotions />} />
      </Route>
      <Route element={<Header />}>
        <Route path='/login' element={<Login />} />
        <Route path='/*' element={<AdminRedirectRoute />} />
      </Route>
    </Routes>
  )
}

export default Page
